module.exports = __webpack_public_path__ + "img/avatar-300-musician-with-guitar.ab7df9ad.png";